import React from 'react';
import { useTalents } from '../hooks/useTalents';
import { TalentsPage } from './Progression/TalentsPage';
import { useTalentRequest } from './Progression/useTalentRequest';

/** All ranks, point totals and reset offers come from the current owner snapshot. */
export const TalentsContent: React.FC = () => {
  const talents = useTalents();
  const { pending, feedback, begin } = useTalentRequest(talents.className);
  return <TalentsPage talents={talents} pending={pending} feedback={feedback}
    onSpend={(treeName, nodeId) => begin({ kind: 'spend', treeName, nodeId }, () => talents.spendTalent(treeName, nodeId))}
    onRespec={() => begin({ kind: 'respec' }, talents.respecTalents)} />;
};
